import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import {
  inlineCaptionFontSizeMapping,
  inlineCaptionLineHeightMapping,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";

const { colors } = constants;
const darkBlue = colors.ui.core[700];
const grey = colors.ui.neutral[400];
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const loadingCss = {
  width: "100%",
  height: "300px",
};

export const figureCss = (isFullWidth: boolean) =>
  isFullWidth
    ? {
        maxWidth: "100%",
        maxHeight: "100%",
        margin: "40px 0 40px auto",
        transition: "max-width .2s",
        display: "flex",
        flexDirection: "column",
      }
    : {
        float: "right",
        maxWidth: "50%",
        maxHeight: "50%",
        margin: "12px 0 40px 37px",
        transition: "max-width .2s",
        [breakpoint.upTo("sm")]: {
          maxWidth: "100%",
          maxHeight: "100%",
          margin: "40px 0",
        },
      };

export const imgButtonCss: CSSObject = {
  position: "relative",
};

export const imageCss: CSSObject = {
  width: "100%",
  height: "100%",
};

export const iconCss: CSSObject = {
  position: "absolute",
  width: "32px",
  height: "32px",
  backgroundColor: darkBlue,
  opacity: ".75",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  bottom: "8px",
  left: "8px",
};

export const captionCss = (
  accessibleFontSize: keyof typeof inlineCaptionFontSizeMapping,
): CSSObject => ({
  fontSize: inlineCaptionFontSizeMapping[accessibleFontSize],
  lineHeight: inlineCaptionLineHeightMapping[accessibleFontSize],
  color: grey,
  paddingTop: "1rem",
});
